import React from "react";
import { Outlet } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";
import SearchOverlay from "@/components/SearchOverlay";
import WhatsAppButton from "@/components/WhatsAppButton";
import CartNudge from "@/components/CartNudge";
import { Toaster } from "@/components/ui/sonner";

export const Layout = () => (
  <div className="min-h-screen flex flex-col bg-lemce-ivory">
    <Header />
    <main className="flex-1">
      <Outlet />
    </main>
    <Footer />
    <CartDrawer />
    <SearchOverlay />
    <WhatsAppButton />
    <CartNudge />
    <Toaster position="bottom-center" />
  </div>
);

export default Layout;
